export interface StockItemReportSearch {
  productTypeId: string;
  search: string;
}
